import { useMemo } from 'react';
import { useRouteMatch } from 'react-router';
import { TaggableResourcePage } from '~/types/models/tags';
import { TestimonialAssetPage } from '~/types/models/testimonial';
import { useSocialTabs } from '../../Socials/Hooks/use-social-tabs';
import { SocialTab } from '../../Socials/util';

/**
 * Gets the current assetPage / activeTabName and return the Taggable Resource page
 * related to the current page/tab;
 * @returns TaggableResourcePage
 */
export function useTaggableResourcePage() {
  const match = useRouteMatch<{ assetPage?: TestimonialAssetPage }>();
  const { assetPage } = match.params;

  const { activeTabName } = useSocialTabs();

  const taggableResourcePage = useMemo(() => {
    if (assetPage) {
      switch (assetPage) {
        case TestimonialAssetPage.Responses:
          return TaggableResourcePage.TestimonialResponses;
        case TestimonialAssetPage.Uploads:
          return TaggableResourcePage.TestimonialUploads;
        case TestimonialAssetPage.All:
        default:
          return TaggableResourcePage.TestimonialAll;
      }
    }

    switch (activeTabName) {
      case SocialTab.Twitter:
        return TaggableResourcePage.SocialTwittter;
      case SocialTab.Youtube:
        return TaggableResourcePage.SocialYoutube;
      default:
        return TaggableResourcePage.SocialAll;
    }
  }, [activeTabName, assetPage]);

  return taggableResourcePage;
}
